import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SyncProcessorService } from '@vending/sync-engine-client';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { TimelogCategoryModel } from 'src/app/models/system/timelog-category';
import { ErrorService } from 'src/packages/mitsBasics';
import { EventsService } from 'src/packages/mitsBasics';
import { LanguageService } from 'src/packages/mitsBasics';
import { OfflineDataService } from 'src/packages/mitsBasics';

@Injectable({
  providedIn: 'root',
})
export class TimelogCategoryService extends OfflineDataService<TimelogCategoryModel> {
  constructor(
    public indexedDBService: NgxIndexedDBService,
    public syncProcessor: SyncProcessorService,
    public http: HttpClient,
    public errorService: ErrorService,
    public events: EventsService,
    private readonly languageService: LanguageService
  ) {
    super(
      indexedDBService,
      syncProcessor,
      'System::TimelogCategory',
      http,
      errorService,
      events,
      'system/timelog_categories/',
      'system_timelog_category',
      ['created_at', 'updated_at', 'remote_id'],
      ['modules', 'translations'],
      undefined,
      true
    );
  }

  /**
   * Ergänzt die aktuelle Sprache, damit die Backend-Suche auch Übersetzungen der
   * Bezeichnung in dieser Sprache berücksichtigt.
   */
  override whereRemote(args: any) {
    const locale = this.languageService.currentLanguage?.languageCode;
    return super.whereRemote(locale ? { ...args, locale } : args);
  }
}
